const BASE = "https://api.hemacabs.com";
const BASE_URL = "https://api.hemacabs.com/api/v1/";

// const BASE_URL = "http://localhost:9001/api/v1/";
// const BASE = "http://localhost:9001";

const PRODUCT = "product";
const HOST_WEB = "http://31.97.206.32:9090/"

export const ENDPOINTS = {
  BASE: BASE_URL,
  IMAGE_BASE: BASE,
  HOST: HOST_WEB,
  asset_url: 'https://api.hemacabs.com/assets/cars/',
  asset_service: 'https://api.hemacabs.com/assets/services/',
  cleanBase: BASE,
  CAR_DETAILS: `${BASE_URL}${PRODUCT}/cars`,
  CAR_DETAIL_ADMIN: `${BASE_URL}${PRODUCT}/cars/admin`,
  addon_services: `${BASE_URL}addon_services`,
  coupons_services: `${BASE_URL}addon_services/coupons-offers`,
  driver_services: `${BASE_URL}addon_services/driver`,
  _services: `${BASE_URL}addon_services/services`,
  deleteFile: `${BASE_URL}file/delete-file`,
  image_gallery: `${BASE_URL}file/upload-file`,
  get_all_image_gallery: `${BASE_URL}product/image-gallery`,
  SEO_DETAILS:`${BASE_URL}seo`,
  PC_DETAILS:`${BASE_URL}page-content`,
  PB_DETAILS:`${BASE_URL}page-build`,
  PB_CONTENTS:`${BASE_URL}page-content/page-build`,
  PB_CONTENTS_SEO:`${BASE_URL}page-content/page-build/seo`,
  ORDERS:`${BASE_URL}product/orders`,
  ORDERS_UPDATE:`${BASE_URL}seo/orders/update`,
  CAR_IMAGE: `${BASE_URL}file/all-upload-car`,

  CREATE: `${BASE_URL}create`,
  GET: `${BASE_URL}get`,
  UPDATE: `${BASE_URL}edit`,
  DELETE: `${BASE_URL}delete`,

};
